const CustomerList = {
  'pages_user_CustomerList.total': '계정그룹 전체',
  'pages_user_CustomerList.path': '사용자 관리',
  'pages_user_CustomerList.customer.path': '고객 목록',
  'pages_user_CustomerList.add_account': '사용자 등록',
  'pages_user_CustomerList.add_customer_portal_account': '신규 계정 생성 (외부 고객)',
  'pages_user_CustomerList.header.customerName': '고객명',
  'pages_user_CustomerList.header.customerDeptName': '고객 사업부명',
  'pages_user_CustomerList.header.userEmail': '담당자 이메일',
  'pages_user_CustomerList.header.userTelNo': '담당자 연락처',
  'pages_user_CustomerList.header.lastLoginDate': '로그인 일시',
  'pages_user_CustomerList.header.lastAccessTime': '최종 접속 시간',
  'pages_user_CustomerList.header.status': '상태',
  'pages_user_CustomerList.header.idp.status': '통합계정 상태',
  'pages_user_CustomerList.row.active': '사용중',
  'pages_user_CustomerList.row.deactive': '사용자 정지',
  'pages_user_CustomerList.row.withdraw': '사용자 탈퇴',
  'pages_user_CustomerList.row.withdraw-button': '탈퇴',
  'pages_user_CustomerList.row.temporary': '임시 계정',
  'pages_user_CustomerList.row.duty': '직무',
  'pages_user_CustomerList.row.isPortalYn': '포털 계정 여부',
  'pages_user_CustomerList.select.group': '전체 계정 그룹',
  'pages_user_CustomerList.customer.total': '고객명 전체',
}

export default CustomerList



// WEBPACK FOOTER //
// ./src/lang/user/CustomerList.kr.js